<template>
  <div class="container mt20" v-loading="isLoading">
    <div class="relative">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="containers mb10">
        <el-breadcrumb-item :to="{ path: '/course' }">课程中心</el-breadcrumb-item>
        <el-breadcrumb-item><span class="hover">课程详情</span></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div v-if="detail">
      <div class="BGwhite pad24 radius8 gray1 flex nowrap initial relative">
        <img :src="detail.ImgPath" @error="imgError" class="BGlight radius8 ImgPath" alt="" />
        <div class="ml30 flex1 right-box">
          <p>
            <span class="ClassifyName"># {{ detail.ClassifyName }}</span>
          </p>
          <p class="ellipsis2 b500 size30 mt10 ohide">
            {{ detail.CourseName }}
          </p>
          <div class="flex between mt20">
            <div class="flex my-star">
              <span class="mr5 red">{{ detail.StarNum }}</span>
              <el-rate :value="detail.StarNum" disabled :colors="['#FFC000', '#FFC000', '#FFC000']"
                disabled-void-color="#CCCCCC"></el-rate>
              <p class="height14px width1px BG00 opacity2 ml30 mr30"></p>
              <img src="@/assets/img/home/4.png" alt="" class="mr5 user" />
              <span class="Corange ml2">{{ detail.StudyView }}</span>
              <p class="height14px width1px BG00 opacity2 ml30 mr30"></p>
              <img src="@/assets/img/home/18.png" alt="" class="time mr5" />
              <span class="Corange ml2">有效期：{{ detail.ValidityDay }}</span>
            </div>
            <!-- <p
              class="BGlight width75px flex b500 cen C555 radius8 line30 Conhover"
              @click="fav()"
            >
              <i
                class="el-icon-star-on mr4 bold"
                style="color: #ff9000"
                v-if="detail.IsFav"
              ></i>
              <i class="el-icon-star-off mr4 bold" v-else></i>
              收藏
            </p> -->
          </div>
          <div class="flex Price">
            <div class="nowrap">
              <span v-if="detail.Price > 0">¥</span>
              <span class="red">{{
                detail.Price > 0 ? detail.Price : "免费"
              }}</span>
              <el-button v-if="!detail.IsBuyed && detail.Price > 0" type="primary" class="ml50 pay"
                @click="pay">立即购买</el-button>
              <el-button v-else type="primary" class="ml50 pay" @click="toChapterDetail()">开始学习</el-button>
            </div>
          </div>

          <div class="flex size16 absolute r b mr25 mb40">
            <template v-if="detail">
              <el-button v-if="detail.IsFx" class="testBtn" @click="popularize()">
                <div class="testBtn">
                  <img src="@/assets/img/home/16.png" alt="" />
                  推广赚钱
                </div>
              </el-button>
              <el-button class="testBtn" @click="fav()">
                <div class="testBtn">
                  <img v-if="detail.IsFav" src="@/assets/img/home/64.png" alt="" />
                  <img v-else src="@/assets/img/home/17.png" alt="" />
                  {{ detail.IsFav == false ? "我要收藏" : "取消收藏" }}
                </div>
              </el-button>
            </template>
          </div>
        </div>
      </div>
      <div class="flex between start nowrap containers mt20 mb80">
        <div class="mr20" style="flex: 1">
          <ul class="flex C666 b500 part04 size16 BGwhite radius8 gray1 mt10">
            <template>
              <li :class="{ Con: tab == 1 }" @click="tab = 1">介绍</li>
              <li :class="{ Con: tab == 2 }" @click="tab = 2">目录</li>
              <li :class="{ Con: tab == 3 }" @click="tab = 3">资料</li>
              <li v-if="detail.IsComment" :class="{ Con: tab == 4 }" @click="tab = 4">
                评论
              </li>
            </template>
          </ul>
          <div class="pad25 radius8 ohide BGwhite radius8 gray1 mt1 detail-tab-box" v-if="detail">
            <div class="jieshao" v-show="tab == 1">
              <p v-if="detail.SuitCrowd" class="my-b-tit mt20">适合人群</p>
              <div class="mt10">{{ detail.SuitCrowd }}</div>
              <p v-if="detail.Brief" class="my-b-tit mt20">课程摘要</p>
              <div class="mt10">{{ detail.Brief }}</div>
              <p v-if="detail.Body" class="my-b-tit mt20">详情介绍</p>
              <div class="content-container-normal" v-html="detail && detail.Body"></div>
            </div>
            <chapter v-show="tab == 2" :chapterList="chapterList" :coursePaper="coursePaper" :data="detail"
              :studyProgress="detail?.studyProgress || 0" v-if="chapterList" />
            <div v-show="tab == 3" class="vh30">
              <fileList :id="detail.CourseID"></fileList>
            </div>
            <comment v-if="tab == 4" :id="detail.CourseID" :data="detail" @update="getDetail">
            </comment>
          </div>
        </div>
        <rightSide class="width290px mt10" v-if="!isLoading" />
      </div>
    </div>
    <codeDialog :show="showCode" :data="codeData" :couseDetail="detail" @closeFun="closeFun"></codeDialog>
  </div>
</template>

<script>
import {
  Course_GetDetail,
  Course_GetCatalogs,
  Course_GetQRCode,
  Course_GetPaper,
} from "@/api/course";
import { CreateOrders } from "@/api/order";
import { Fav_Save } from "@/api/common";
import codeDialog from "@/components/codeDialog.vue";
import comment from "./child/comment.vue";
import chapter from "./child/chapter.vue";
import rightSide from "./child/rightSide.vue";
import fileList from "./child/fileList.vue";
export default {
  name: "courseDetaial",
  components: {
    codeDialog,
    comment,
    rightSide,
    chapter,
    fileList,
  },
  data() {
    return {
      tab: 1,
      showCode: false,
      codeData: null,
      isLoading: false,
      detail: null,
      chapterList: null,
      coursePaper: null,
      fileLoading: false,
      fileList: null,
    };
  },
  watch: {
    "$route.query.tab"(newValue) {
      if (newValue === undefined) {
        this.$router.go(0);
      }
    },
    "$route.query.CourseID"(newValue) {
      if (newValue) {
        this.getDetail();
      }
    },
    tab(v) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          tab: v,
        },
      });
    },
  },
  created() {
    const { tab, ShareAuthKey } = this.$route.query;
    if (tab) {
      this.tab = Number(tab);
    }
    if (ShareAuthKey) {
      localStorage.setItem("ShareAuthKey", ShareAuthKey);
    }
    this.getChapterList();
    this.getCoursePaper();
    // this.getCourseFileList();
    this.getDetail();
  },
  methods: {
    toChapterDetail() {
      this.$router.push({
        path: "/chapterDetail",
        query: {
          CourseID: this.$route.query.CourseID,
          ChapterID: this.chapterList[0].Chapters[0].ChapterID,
        },
      });
    },
    pay() {
      console.log("pay");
      CreateOrders({
        RelatedType: 1,
        RelatedID: this.$route.query.CourseID,
        ShareAuthKey: localStorage.getItem("ShareAuthKey"),
      }).then((res) => {
        if (res.code == 0) {
          this.$router.push({
            path: "/confirmOrder",
            query: {
              OrdersID: res.data.OrdersID,
            },
          });
        }
      });
    },
    closeFun() {
      this.showCode = false;
    },
    popularize() {
      Course_GetQRCode({ CourseID: this.detail.CourseID })
        .then((res) => {
          if (res.code === 0) {
            this.showCode = true;
            this.codeData = { ...res.data, ...this.detail };
            this.$refs.codeDialog.setData(res.data);
          }
        })
        .catch(() => { });
    },
    fav() {
      // 1收藏 0取消
      const data = {
        RelatedType: 1,
        RelatedID: this.detail.CourseID,
        StatusID: this.detail.IsFav ? 0 : 1,
      };
      Fav_Save(data).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: this.detail.IsFav ? "取消收藏成功" : "收藏成功",
            type: "success",
          });
          this.detail.IsFav = !this.detail.IsFav;
        }


      });
    },
    getChapterList() {
      Course_GetCatalogs({ CourseID: this.$route.query.CourseID })
        .then((res) => {
          this.chapterList = res.data;
        })
        .catch(() => { });
    },
    // getCourseFileList() {
    //   this.fileLoading = true;
    //   Course_GetFileList({ CourseID: this.$route.query.CourseID })
    //     .then((res) => {
    //       this.fileLoading = false;
    //       this.fileList = [
    //         {
    //           FileID: 0,
    //           FileName: "112312",
    //           FileExt: "DOC",
    //           FileSize: 0,
    //           FileSizeTxt: "1231",
    //         },
    //         {
    //           FileID: 0,
    //           FileName: "112312",
    //           FileExt: "PDF",
    //           FileSize: 0,
    //           FileSizeTxt: "1231",
    //         },
    //         {
    //           FileID: 0,
    //           FileName: "112312",
    //           FileExt: "ZIP",
    //           FileSize: 0,
    //           FileSizeTxt: "1231",
    //         },
    //         {
    //           FileID: 0,
    //           FileName: "112312",
    //           FileExt: "PPT",
    //           FileSize: 0,
    //           FileSizeTxt: "1231",
    //         },
    //         {
    //           FileID: 0,
    //           FileName: "112312",
    //           FileExt: "RAR",
    //           FileSize: 0,
    //           FileSizeTxt: "1231",
    //         },
    //         {
    //           FileID: 0,
    //           FileName: "112312",
    //           FileExt: "TXT",
    //           FileSize: 0,
    //           FileSizeTxt: "1231",
    //         },
    //         {
    //           FileID: 0,
    //           FileName: "112312",
    //           FileExt: "7Z",
    //           FileSize: 0,
    //           FileSizeTxt: "1231",
    //         },
    //         {
    //           FileID: 0,
    //           FileName: "112312",
    //           FileExt: "312",
    //           FileSize: 0,
    //           FileSizeTxt: "1231",
    //         },
    //         {
    //           FileID: 0,
    //           FileName: "112312",
    //           FileExt: "312",
    //           FileSize: 0,
    //           FileSizeTxt: "1231",
    //         },
    //         {
    //           FileID: 0,
    //           FileName: "112312",
    //           FileExt: "312",
    //           FileSize: 0,
    //           FileSizeTxt: "1231",
    //         },
    //         {
    //           FileID: 0,
    //           FileName: "112312",
    //           FileExt: "312",
    //           FileSize: 0,
    //           FileSizeTxt: "1231",
    //         },
    //         {
    //           FileID: 0,
    //           FileName: "112312",
    //           FileExt: "312",
    //           FileSize: 0,
    //           FileSizeTxt: "1231",
    //         },
    //         {
    //           FileID: 0,
    //           FileName: "112312",
    //           FileExt: "312",
    //           FileSize: 0,
    //           FileSizeTxt: "1231",
    //         },
    //         {
    //           FileID: 0,
    //           FileName: "112312",
    //           FileExt: "312",
    //           FileSize: 0,
    //           FileSizeTxt: "1231",
    //         },
    //         {
    //           FileID: 0,
    //           FileName: "112312",
    //           FileExt: "312",
    //           FileSize: 0,
    //           FileSizeTxt: "1231",
    //         },
    //         {
    //           FileID: 0,
    //           FileName: "112312",
    //           FileExt: "312",
    //           FileSize: 0,
    //           FileSizeTxt: "1231",
    //         },
    //         {
    //           FileID: 0,
    //           FileName: "112312",
    //           FileExt: "312",
    //           FileSize: 0,
    //           FileSizeTxt: "1231",
    //         },
    //       ];
    //     })
    //     .catch(() => {});
    // },
    getCoursePaper() {
      Course_GetPaper({ CourseID: this.$route.query.CourseID })
        .then((res) => {
          this.coursePaper = res.data || {};
        })
        .catch(() => { });
    },
    getDetail(reload = false) {
      this.detail = null;
      if (!reload) {
        this.isLoading = true;
      }

      // console.log(this.$route.query, '哈哈哈')

      Course_GetDetail({
        CourseID: this.$route.query.CourseID,
      })
        .then((res) => {
          this.isLoading = false;
          this.detail = res.data;
          this.detail.MyEvaluateStarNum = res.data.MyEvaluateStarNum
            ? Number(this.detail.MyEvaluateStarNum)
            : 0;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    toCard() {
      if (this.title1 === "随堂小测" && this.testStatus) {
        this.$router.push({ path: "/card/detail", query: this.$route.query });
      } else {
        this.$message.error("还未开始随堂小测！");
      }
    },
  },

  destroyed() {
    if (this.testCdTimer) {
      clearInterval(this.testCdTimer);
      this.testCdTimer = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.detail-tab-box {
  min-height: 900px;
}

.ImgPath {
  width: 420px;
  height: 315px;
  border-radius: 6px;
}

.Price {
  position: absolute;
  bottom: 40px;
  color: #e12a14;
  font-size: 20px;
  font-weight: bold;

  .red {
    font-weight: bold;
    font-size: 24px;
    color: #e12a14;
  }

  .pay {
    width: 144px;
    height: 52px;
    font-size: 18px;
    background: #1d79ff;
    border-radius: 6px;
  }
}

.myProgress {
  .el-progress-bar {
    width: 75%;
  }
}

.right-box {
  padding-top: 40px;

  .ClassifyName {
    background: #e5f0ff;
    border-radius: 6px;
    font-size: 16px;
    color: #1d79ff;
    padding: 5px 10px;
  }

  .my-star {
    font-size: 20px;
    display: flex;
    align-items: center;

    .Corange {
      color: #666666;
      font-size: 18px;
      font-weight: 400;
    }

    .user {
      width: 12px;
      height: 17px;
    }

    .time {
      width: 17px;
      height: 17px;
    }
  }
}

.red {
  color: #e12a14;
  font-weight: bold;
}

.Title {
  padding: 0;
  padding-top: 10px;
  font-size: 14px;

  .topics {
    margin-right: 10px;
    margin-bottom: 10px;
    border-radius: 16px;
    background: #e3edff;
    color: #376ff6;
    height: 26px;
    line-height: 22px;
  }

  .keywords {
    margin-right: 10px;
    margin-bottom: 10px;
    border-radius: 16px;
    background: #f1f4f6;
    color: #999999;
    height: 26px;
    line-height: 22px;
  }
}

.fullsummary {
  font-size: 14px;
  padding: 15px 20px;
  background: #f5f5f5;
  font-family: HarmonyOS_Sans_SC_Medium;
  border-radius: 6px;
  letter-spacing: 2spx;
  /* 增加字符间距 */
}

.testBtn {
  height: 46px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  line-height: 1;

  img {
    display: block;
    width: 24px;
    height: 24px;
    margin-right: 5px;
    margin-left: -5px;
  }
}

.jieshao {
  padding-left: 40px;
  font-weight: 400;
  font-size: 18px;
  color: #666666;

  .keywords {
    span {
      margin-right: 20px;
    }
  }
}

.my-b-tit {
  font-weight: 600;
}
</style>
